export default [
  {
    path: '/questionnaire',
    name: 'questionnaire',
    meta: {
      title: '活动报名'
    },
    component: () => import('@/views/questionnaire')
  },
  {
    path: '/questionnaire/detail',
    name: 'questionnaireDetail',
    meta: {
      title: '活动详情'
    },
    component: () => import('@/views/questionnaire/detail')
  },
  {
    path: '/questionnaire/store',
    name: 'questionnaireStore',
    meta: {
      title: '选择门店'
    },
    component: () => import('@/views/questionnaire/store')
  }
]
